import React from 'react';

import { Drawer, Button } from 'antd';

// Исключение ТС
import ExcludedTsForm from '../../../containers/ProfileCard/OLD-REPA/add_employee/excluded_ts';

class ExcludedVehicles extends React.PureComponent {
  render() {
    const {
      handleClickExcludeVehiclesHide,
      handleClickExcludeVehicles,
      visible,
    } = this.props;

    return (
      <Drawer
        title={
          <div>
            <h2>Исключить ТС</h2>Александровский Александр Александрович
          </div>
        }
        width={896}
        placement={'left'}
        closable={false}
        onClose={handleClickExcludeVehiclesHide}
        visible={visible}
      >
        <Button
          className="exclude_ts__hide"
          onClick={handleClickExcludeVehiclesHide}
          type="primary"
          shape="circle"
          icon="close"
          size={'small'}
        />
        <ExcludedTsForm handle_exclude_ts={handleClickExcludeVehicles} />
      </Drawer>
    );
  }
}

export default ExcludedVehicles;
